export const SELECTED_VARIANT_KEYS = ["variants", "variants2", "products", "products2"];

export const getSelectedVariantItems = (variantsCategory, key) =>
  Array.isArray(variantsCategory?.[key]) ? variantsCategory[key] : [];

export const normalizeSelectedVariantCategory = (variantsCategory = {}) => ({
  ...variantsCategory,
  variants: getSelectedVariantItems(variantsCategory, "variants"),
  variants2: getSelectedVariantItems(variantsCategory, "variants2"),
  products: getSelectedVariantItems(variantsCategory, "products"),
  products2: getSelectedVariantItems(variantsCategory, "products2"),
});

export const normalizeSelectedVariants = (selectedVariants) => {
  if (selectedVariants === false) return false;
  if (!Array.isArray(selectedVariants)) return [];
  return selectedVariants.map(normalizeSelectedVariantCategory);
};

export const getSelectedVariantsPrice = (selectedVariants) => {
  let price = 0;
  for (const variantsCategory of normalizeSelectedVariants(selectedVariants) || []) {
    for (const key of SELECTED_VARIANT_KEYS) {
      for (const item of variantsCategory[key]) {
        price += (parseFloat(item.price) || 0) * (parseInt(item.qty) || 0);
      }
    }
  }
  return price;
};
